import { render, staticRenderFns } from "./app-card-list.vue?vue&type=template&id=b82d42e2&scoped=true&"
import script from "./app-card-list.vue?vue&type=script&lang=js&"
export * from "./app-card-list.vue?vue&type=script&lang=js&"
import style0 from "./app-card-list.vue?vue&type=style&index=0&id=b82d42e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82d42e2",
  null
  
)

export default component.exports